var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({staticClass:"common-layout-left-right-wrap clearFloat"},'div',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"left-wrap",style:(_vm.wrapStyle.left)},[_vm._t("left")],2),_vm._v(" "),_c('div',{staticClass:"right-wrap",style:(_vm.wrapStyle.right)},[_vm._t("right")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-673711c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/LeftRightLayout.vue
// module id = null
// module chunks = 